<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules">
    <mail-list
        :value="innerValue"
        :required="required"
        :error-messages="errors"
        :readonly="readonly"
        :label="label"
        :required-color="requiredColor"
        @input="change" />
  </ValidationProvider>
</template>

<script>
  import MailList from './MailList.vue'
  export default {
    components: {
      MailList
    },
    props: {
      value: {
        type: Array,
        default: null
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      }
      // innerValue (val) {
      //   this.$emit('input', val)
      // }
    },
    methods: {
      change: function (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>
